/** 账号删除送审智能工单模板 id */
export const DELETE_ACCOUNT_WORK_TEMP_ID = 74;

export const stepKey = {
  confirmDeleteType: 'confirmDeleteType', // 1、确认删除类型
  agreeTerms: 'agreeTerms', // 2、同意条款
  formInput: 'formInput', // 3、表单输入
  emailNotice: 'emailNotice', // 4、邮件通知
  coolingOffChoose: 'coolingOffChoose', // 5、冷静期
  secondCheckDelete: 'secondCheckDelete', // 6、二次确认删除
  deleteResult: 'deleteResult' // 7、删除结果
};
